var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-header',{staticClass:"border-1"},[_c('b-row',[_c('b-col',{staticClass:"ms-auto"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.title))])]),_c('b-col',{staticClass:"text-right"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }